import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from '@/App'
import { restoreDeepLink } from '@/lib/restoreDeepLink'
import '@/styles/global.css'

// Must run before the router reads the current location.
restoreDeepLink()

const container = document.getElementById('root')
if (!container) throw new Error('Root element #root is missing from index.html')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
